import { UI_HeroCard } from 'ui/components/2-molecules/Card/HeroCard/HeroCard';
import { DynamicPlayer } from './DynamicPlayer';

export const HeroCard = ({ content, settings }: Content.HeroCard) => {
	const { video, link } = content ?? {};
	const { url, name, target } = link ?? {};
	const { layout } = settings?.properties ?? {};

	return <UI_HeroCard {...content} layout={layout} link={{ url, name, target }} player={video && <DynamicPlayer url={video.url} loop={true} />} />;
};
